import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useStore from "../../lib/store";
import { NAV_TREE } from "../../lib/navigation";

const TreeLeaf = ({ node, depth, isLast, ancestorLines }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const openBuffer = useStore((s) => s.openBuffer);
  const hasChildren = node.children && node.children.length > 0;
  const [expanded, setExpanded] = useState(hasChildren);
  const isActive = location.pathname === node.route;

  const branch = isLast ? "└── " : "├── ";
  const prefix =
    ancestorLines.map((last) => (last ? "│   " : "    ")).join("") + branch;

  const handleRowClick = () => {
    // Clicking the row (name/prefix) opens the node — folders navigate to
    // their listing route, files to the buffer route.
    openBuffer(node.buffer);
    navigate(node.route);
  };

  const handleArrowClick = (e) => {
    // Clicking the arrow only toggles expand/collapse.
    e.stopPropagation();
    setExpanded((ex) => !ex);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleRowClick();
    }
  };

  return (
    <>
      <div
        className={`neotree-node${isActive && !hasChildren ? " active" : ""}`}
        onClick={handleRowClick}
        onKeyDown={handleKeyDown}
        role={hasChildren ? "treeitem" : "link"}
        tabIndex={0}
        aria-expanded={hasChildren ? expanded : undefined}
      >
        <span className="neotree-prefix">{prefix}</span>
        <span
          className={`neotree-arrow${expanded ? " expanded" : ""}`}
          onClick={handleArrowClick}
          role="button"
          tabIndex={-1}
          aria-label={hasChildren ? (expanded ? "Collapse" : "Expand") : undefined}
        >
          {hasChildren ? "▸" : ""}
        </span>
        <span className={`neotree-name${hasChildren ? " folder" : ""}`}>
          {node.name}
        </span>
      </div>
      {hasChildren &&
        expanded &&
        node.children.map((child, i) => (
          <TreeLeaf
            key={child.name}
            node={child}
            depth={depth + 1}
            isLast={i === node.children.length - 1}
            ancestorLines={[...ancestorLines, !isLast]}
          />
        ))}
    </>
  );
};

const NeoTree = () => {
  const navigate = useNavigate();

  return (
    <aside className="neotree" aria-label="File explorer">
      <button
        type="button"
        className="neotree-title"
        onClick={() => navigate("/")}
      >
        portfolio/
      </button>
      <div role="tree" aria-label="Portfolio files">
        {NAV_TREE.map((node, i) => (
          <TreeLeaf
            key={node.name}
            node={node}
            depth={0}
            isLast={i === NAV_TREE.length - 1}
            ancestorLines={[]}
          />
        ))}
      </div>
    </aside>
  );
};

export default NeoTree;